import React, { useContext } from "react";
import { ThemeContext } from "styled-components";

import {
  Section,
  NavigationLinks,
  SectionContent,
} from "../../../../components";

import { WidgetCardSection, BannerHome, AlertaSection } from "../../sections";
import { ReactComponent as ImageNavigationLink } from "../../../../assets/images/catalogo/ilustracao-mulher-trofeu.svg";

const HomePage = () => {
  const { color } = useContext(ThemeContext);
  return (
    <>
      <BannerHome />
      <Section sectionName="alerta" as={AlertaSection} />
      <Section
        sectionName="nome da secao analytics"
        as={NavigationLinks}
        image={<ImageNavigationLink />}
      />
      <Section sectionName="nome da secao analytics" as={WidgetCardSection} />
      <Section sectionName="dados do thema">
        <SectionContent>
          <pre>
            <code>{JSON.stringify({ ...color }, null, 3)}</code>
          </pre>
        </SectionContent>
      </Section>
    </>
  );
};

HomePage.propTypes = {};

export default HomePage;
